export const NOTIFICATION_TYPE = {
  Success: 'success',
  Info: 'info',
  Warning: 'warning',
  Error: 'error',
};
